<template>
    <div>
        <div
            class="grid grid-cols-1 gap-3 lg:mb-0 lg:hidden"
            :class="{
                hidden: route.query.partner !== '',
            }"
        >
            <div
                v-for="item in getGamesProvidersByType(route?.params?.type)"
                :key="item.id"
            >
                <ThaBlocksProviderCardMobile
                    :item="item"
                    :game-type="route?.params?.type"
                    @partner-selected="changePartner"
                />
            </div>
        </div>
        <div
            class="lg:min-h-[700px]"
            :class="{
                'hidden lg:block': route.query.partner === '',
            }"
        >
            <div
                v-if="listProviderGame?.length > 0"
                class="hidden gap-2 rounded-3xl bg-grey-50 p-4 lg:flex lg:flex-wrap"
            >
                <div
                    v-for="(item, idx) in listProviderGame"
                    :key="item.id"
                    :class="[
                        {
                            '!border-bigg-red font-semibold !text-black':
                                item.id === partner,
                        },
                    ]"
                    class="relative flex cursor-pointer flex-wrap items-center justify-center gap-1 rounded-full border-2 border-grey-200 bg-white px-3 py-[6px] text-sm text-grey"
                    @click="changePartner(item.id)"
                >
                    <img
                        class="icon h-[24px] w-[24px] object-contain"
                        :class="[
                            { active: item.id === partner },
                            { 'h-[15px] w-[38px]': item.id === 'mitek' },
                            {
                                'h-[24px] w-[37px]': item.id === 'cq9',
                            },
                        ]"
                        :src="`/assets/icons/casino/provider/${
                            item.id === partner && !item.id
                                ? 'all-active'
                                : item.id === partner
                                  ? item.id + '-active'
                                  : item.id
                                    ? item.id
                                    : 'all'
                        }.svg`"
                        alt="icon"
                    />
                    {{ idx === 0 ? $t(item.name) : item.name }}
                    <span v-if="item.label === 'hot'">
                        <img
                            class="absolute right-1 top-0 h-auto w-5"
                            :src="`${staticUrl}/assets/icons/fire.gif`"
                            loading="lazy"
                    /></span>
                    <span v-if="item.label === 'new'">
                        <img
                            class="absolute right-0 top-0 h-auto w-6"
                            :src="`${staticUrl}/assets/icons/star.gif`"
                            loading="lazy"
                    /></span>
                </div>
            </div>
            <!-- Mobile header -->
            <div v-if="listProviderGame?.length > 0" class="lg:hidden">
                <ThaCommonHeaderProviderGames
                    :filter="FILTER_KEYWORD"
                    :providers="getGamesProvidersByType(route?.params?.type)"
                    :is-splice="false"
                    @on-change="handleSearchsDebouncedMobile"
                    @on-partner-selected="handleChangeProviderMobile"
                    @on-change-filter="onChangeFilter"
                />
            </div>

            <!-- filter desktop -->
            <div
                class="hidden items-center justify-between gap-3 pb-6 lg:mt-6 lg:flex lg:gap-4"
            >
                <!-- filter desktop -->
                <div
                    class="relative hidden w-full justify-between md:ml-auto lg:flex"
                >
                    <div
                        class="hide-scroll-bar flex h-auto flex-nowrap gap-3 overflow-x-scroll lg:gap-[10px] lg:overflow-hidden"
                    >
                        <div
                            v-for="item in FILTER_KEYWORD"
                            :key="item.id"
                            class="flex items-center"
                        >
                            <input
                                :id="item.id"
                                v-model="filter"
                                type="radio"
                                :value="item.value"
                                :name="item.name"
                                class="hidden"
                                :disabled="isLoading"
                                @change="handleFilter()"
                            />
                            <label
                                :for="item.id"
                                class="flex cursor-pointer items-center rounded-full bg-grey-200 px-3 py-2 text-sm leading-5 text-black"
                                :class="{
                                    '!bg-bigg-red font-semibold text-white':
                                        filter === item.key,
                                }"
                                >{{ $t(item.i18_key) }}</label
                            >
                        </div>
                    </div>
                </div>
                <!-- search desktop -->
                <div class="relative hidden lg:flex">
                    <button
                        class="absolute left-2 top-0 h-full p-2.5 text-sm font-medium text-slate-400 focus:outline-none"
                        @click="handleSearch"
                    >
                        <svg
                            class="h-4 w-4"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 20 20"
                        >
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                            />
                        </svg>
                    </button>
                    <input
                        id="games_keyword"
                        v-model="keyword"
                        type="text"
                        class="block min-w-[270px] rounded-3xl border border-grey-200 bg-white p-1.5 pl-10 text-sm text-black focus:border-bigg-yellow focus:ring-bigg-yellow xl:pr-5"
                        :placeholder="$t('common.search')"
                        maxlength="20"
                        required
                        @input="handleSearchsDebounced()"
                    />
                </div>
            </div>

            <ThaCommonLoaderGridCards
                v-if="isLoading"
                :cols="2"
                :lgcols="5"
                :count="8"
            />
            <div v-else class="space-y-2">
                <div
                    class="grid grid-cols-2 gap-2 lg:grid-cols-4 lg:gap-4 xl:grid-cols-5"
                >
                    <template
                        v-for="game in games.items"
                        :key="game.partner_game_id"
                    >
                        <ThaCommonGameCard
                            :data="game"
                            :jackpotvalue="findJacpot(game)"
                            @click="handleGetGameUrl(game)"
                        />
                    </template>
                </div>
                <div
                    v-if="page < totalPage"
                    class="flex justify-center pt-2 lg:pt-8"
                >
                    <ThaCommonButton
                        :loading="isShowMore"
                        type="button"
                        @click="handleShowMore"
                    >
                        {{ $t('common.show_more') }}
                    </ThaCommonButton>
                </div>
                <div v-if="games?.items?.length === 0">
                    <ThaBlocksNoDataGames />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import {
    useGamesStore,
    useJackpotStore,
    useProviderStore,
    useAlertStore,
    useModalStore,
    useUserStore,
} from '~/stores'

import { storeToRefs } from 'pinia'
import { useWindowSize } from '@vueuse/core'

const staticUrl = useRuntimeConfig().public.staticUrl

const { width } = useWindowSize()

const alertStore = useAlertStore()
// const useUserStoreInstance = useUserStore()
// const { isLoggedIn } = storeToRefs(useUserStoreInstance)
const route = useRoute()
const router = useRouter()
const useGamesStoreInstance = useGamesStore()
const useJackpotStoreInstance = useJackpotStore()
const useProviderStoreInstance = useProviderStore()

const { getGamesProvidersByType, getGamesProvidersAllByType } =
    useProviderStoreInstance

// extract specific store properties
const { games } = storeToRefs(useGamesStoreInstance)
const { jackpots } = storeToRefs(useJackpotStoreInstance)
const partner = ref('')
partner.value = route.query.partner
// extract specific store actions
const { getGames, getGameUrl } = useGamesStoreInstance
const keyword = ref('')
const isLoading = ref(false)
const isShowMore = ref(false)
const page = ref(1)
const totalPage = ref(1)
const filter = ref('all')
const type = ref('')
const { t } = useI18n({})

const FILTER_KEYWORD = [
    {
        id: 'all',
        key: 'all',
        value: 'all',
        i18_key: 'filter.all',
        name: 'game_filter',
    },
    // { id: 'az', value: 'az', i18_key: 'filter.A-Z', name: 'game_filter' },
    {
        id: 'hot',
        key: 'hot',
        value: 'hot',
        i18_key: 'filter.hot',
        name: 'game_filter',
    },
    // {
    //     id: 'recent',
    //     value: 'recent',
    //     i18_key: 'filter.recent',
    //     name: 'game_filter',
    // },
    {
        id: 'new',
        key: 'new',
        value: 'new',
        i18_key: 'filter.new',
        name: 'game_filter',
    },
]
// not use - We get the provider position by the API
// const sortProvider = (item) => {
//     return item.sort((a, b) => {
//         if (a.stt === undefined && b.stt !== undefined) {
//             return -1
//         }
//         if (a.stt !== undefined && b.stt === undefined) {
//             return 1
//         }
//         if (a.stt === undefined && b.stt === undefined) {
//             return 0
//         }
//         return a.stt - b.stt
//     })
// }

const listProviderGame = computed(() => {
    return width.value > 1023
        ? getGamesProvidersAllByType(route?.params?.type)
        : getGamesProvidersByType(route?.params?.type)
})

const handleSearch = async (isShowMore = false) => {
    try {
        if (!isShowMore) {
            isLoading.value = true
        }
        page.value = 1
        const { data } = await getGames({
            type: type.value ? type.value : route?.params?.type || '',
            filter: filter.value || '',
            keyword: keyword.value || '',
            page: page.value,
            partner: partner.value,
        })
        totalPage.value = data.value.totalPage
    } catch (error) {
        console.log(error)
        alertStore.showMessageError(error)
    } finally {
        isLoading.value = false
    }
}

const onChangeFilter = (item) => {
    filter.value = item
    handleSearch()
}

const handleSearchsDebouncedMobile = useDebounceBigg(async (payload) => {
    if (payload) {
        keyword.value = payload
    } else {
        keyword.value = ''
    }

    await handleSearch()
}, 600)
const handleSearchsDebounced = useDebounceBigg(async () => {
    await handleSearch()
}, 600)

const handleChangeProviderMobile = (item) => {
    router.push({ query: { partner: item.key } })
    partner.value = item.key
    // await handleSearch()
    // serach invoked by watch
}
const changePartner = async (payload) => {
    router.push({ query: { partner: payload } })
    partner.value = payload
    // serach invoked by watch
    // serach invoked by watch
}

const handleFilter = async () => {
    try {
        isLoading.value = true
        page.value = 1
        await handleSearch()
    } catch (error) {
        console.error(error)
    } finally {
        isLoading.value = false
    }
}

const { isMobile } = useDevice()
const useUserStoreInstance = useUserStore()
const useModalStoreInstance = useModalStore()
const handleGetGameUrl = async (payload) => {
    if (!useUserStoreInstance.isLoggedIn) {
        useModalStoreInstance.showLoginModal = true
        return
    }
    const toSend = {
        partnerProvider: payload.partner_provider,
        partnerGameId: payload.partner_game_id,
    }
    if (isMobile) {
        const newtab = window.open('', '_blank')
        try {
            const { data } = await getGameUrl(toSend)
            if (data?.value?.status === 'OK') {
                const { url } = data.value.data
                if (newtab) newtab.location.href = url
            } else if (data?.value?.data?.url === '') {
                if (newtab) newtab.close()
                // NO URL recieved
                alertStore.showMessageError({
                    value: {
                        statusCode: 'SHOW_MESSAGE',
                        message: t('error.server_is_busy'),
                    },
                })
            } else if (data.value === null) {
                // no auth
                if (newtab) newtab.close()
            }
        } catch (error) {
            if (newtab) newtab.close()
            alertStore.showMessageError(error)
        }
    } else {
        const { data } = await getGameUrl(toSend)
        if (data?.value?.status === 'OK') {
            const { url } = data.value.data
            navigateTo(url, {
                open: {
                    target: '_blank',
                },
            })
        }
    }
}
const handleShowMore = async () => {
    if (page.value === totalPage.value) return
    try {
        isShowMore.value = true
        page.value = page.value + 1
        const { data } = await getGames({
            type: type.value ? type.value : route?.params?.type || '',
            filter: filter.value || '',
            keyword: keyword.value || '',
            page: page.value,
            partner: partner.value,
        })
        totalPage.value = data.value.totalPage
    } catch (error) {
        console.error(error)
    } finally {
        isShowMore.value = false
    }
}
const findJacpot = (game) => {
    return jackpots.value[game.partner_game_id]
}

// const input = ref(null)
// const hideMobileKeyboard = () => {
//     input.value.blur()
// }

// get games on server
await handleSearch()

watch(
    () => route.query.partner,
    async (newVal) => {
        page.value = 1
        totalPage.value = 1
        keyword.value = ''
        partner.value = newVal
        await handleSearch()
    },
    { immediate: false, deep: false }
)

// refetch when language changes
const { locale } = useI18n()
watch(
    () => locale.value,
    async (newVal, oldVal) => {
        if (newVal !== oldVal) {
            await handleSearch()
        }
    },
    { immediate: false, deep: false }
)
</script>
<style lang="scss" scoped>
.icon {
    filter: brightness(0) saturate(100%) invert(66%) sepia(4%) saturate(30%)
        hue-rotate(44deg) brightness(90%) contrast(91%);
    &.active {
        filter: unset;
    }
}
</style>
